import React from 'react';
import { View, Platform } from 'react-native';
import { createStackNavigator } from '@react-navigation/stack';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { LoginOrSignupScreen, HomeScreen } from '../screens';
import { HeaderLogo } from './shared/header.logo';


const Stack = createStackNavigator();


export const HomeStack = ({ navigation }) => (
    <Stack.Navigator>
        <Stack.Screen
            name='Home'
            component={HomeTabNavigator}
            // component={HomeScreen}
            options={{
                // headerTitleAlign: 'center',
                headerLeft: () => <MenuAction />,
                headerTitle: () => <HeaderLogo />,
                headerRight: () => (
                    <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Button size='small' style={{ marginRight: 5 }} appearance='ghost' status='basic' onPress={() => navigation.navigate('Account', { actionType: 'login' })}>
                            Login
                        </Button>
                        <Button size='small' style={{ marginRight: 20 }} onPress={() => navigation.navigate('Account', { actionType: 'signup' })}>
                            Sign Up
                        </Button>
                    </View>
                ),
            }}
        />
        <Stack.Screen
            name='Account'
            component={LoginOrSignupScreen}
            /* options={{ title: '', headerRight: () => <MenuAction />}} */
        />
    </Stack.Navigator>
);



import { poallImages } from '../constants/images';
import { MobileOrTabletAndLarger } from '../components/containers/ResponsiveComponents';
import { ProductScreen, PricePlansScreen, AboutScreen } from '../screens/home.screen';
import { BrandText } from '../components/brandText';
import { MenuAction } from './shared/sidebar.menu';
import { Avatar, Button, Layout, TabBar, Tab } from '../components/_primatives';
const { Navigator, Screen } = createMaterialTopTabNavigator();


const TopTabBar = ({ navigation, state }) => (
    <TabBar 
        selectedIndex={state.index}
        onSelect={index => navigation.navigate(state.routeNames[index])}
    >
        <Tab title='Home' style={{ padding: 10 }} />
        <Tab title='Product' style={{ padding: 10 }} />
        <Tab title='Price' style={{ padding: 10 }} />
        <Tab title='About' style={{ padding: 10 }} />
    </TabBar>
);

const HomeTabNavigator = () => (
    <Navigator
        tabBar={(props) => (
            <Layout level='1'>
                <Layout level='1' style={[{ maxWidth: 750, alignSelf: 'center', width: '100%' }, Platform.OS === 'web' ? { marginLeft: -15 } : {}]}>
                    <TopTabBar {...props} />
                </Layout>
            </Layout>
        )}
        swipeEnabled={false}
    >
        <Screen name='Home' component={HomeScreen} />
        {/* <Screen name='Home' component={AboutScreen} /> */}
        <Screen name='Product' component={ProductScreen} />
        <Screen name='Price' component={PricePlansScreen} />
        <Screen name='About' component={AboutScreen} />
    </Navigator>
);